import { ITutorialPassos, MensagensPadrao } from "../../../Components/AdicionarAjuda";

export const IDs = {
    formularioDeFiltro: "formulario-de-filtros-do-plano-de-contas",

    filtroDeEmpresa: "campo-empresa-filtros-do-plano-de-contas",
    filtroDeCodigoContabil: "campo-empresa-filtros-do-codigo-contabil",
    filtroDeDescricao: "campo-nome-filtros-do-plano-de-contas",
    filtroDeAtivo: "campo-ativo-filtros-do-plano-de-contas",
    filtroDeClassificacao: "campo-classificacao-filtros-do-plano-de-contas",
    filtroDeTipo: "campo-tipo-filtros-do-plano-de-contas",

    botaoListar: "botao-listar-plano-de-contas",
    botaoAdicionar: "botao-adicionar-plano-de-contas",
}

export const Classes = {
    botaoEditar: "botao-editar-plano-de-contas",
    botaoDesativar: "botao-desativar-plano-de-contas",
}

export const ConsultarPlano: ITutorialPassos = {
    steps: [
        { ...MensagensPadrao.filtros.apresentacao, target: () => document.getElementById(IDs.formularioDeFiltro)! },
        { ...MensagensPadrao.filtros.empresa, target: () => document.getElementById(IDs.filtroDeEmpresa)! },
        { ...MensagensPadrao.filtros.descricao, target: () => document.getElementById(IDs.filtroDeDescricao)! },
        { title: "Código contábil", description: "Indique o código contábil se desejar", target: () => document.getElementById(IDs.filtroDeCodigoContabil)! },
        { ...MensagensPadrao.filtros.tipo, target: () => document.getElementById(IDs.filtroDeTipo)! },
        {
            title: "Filtro de classificação",
            description: "Selecione a classificação do plano de conta a ser buscado.",
            target: () => document.getElementById(IDs.filtroDeClassificacao)!,
        },
        { ...MensagensPadrao.filtros.ativo, target: () => document.getElementById(IDs.filtroDeAtivo)! },
        { ...MensagensPadrao.filtros.botaoListar, target: () => document.getElementById(IDs.botaoListar)! },
    ]
}

export const AdicionarPlano: ITutorialPassos = {
    steps: [
        { ...MensagensPadrao.adicionar.entrada, target: () => document.getElementById(IDs.botaoListar)! },
    ]
}

export const EditarPlano: ITutorialPassos = {
    steps: [
        { ...MensagensPadrao.alterar.editar, target: () => document.querySelector('.' + Classes.botaoEditar)! },
    ]
}

export const DesativarPlano: ITutorialPassos = {
    steps: [
        { ...MensagensPadrao.alterar.desativar, target: () => document.querySelector('.' + Classes.botaoDesativar)! },
    ]
}